import { useWatch } from 'react-hook-form';
import { CalculatedPriceFieldProps } from '../components/CalculatedPriceField';
import { QuickbooksCalculatedPriceField } from '../components/QuickbooksCalculatedPriceField';
import { Line } from '../types';

export type SubTotalFieldProps = Omit<CalculatedPriceFieldProps, 'price'> & {
  notifyProductsChange: () => void;
};

export const SubTotalField = (
  props: Omit<CalculatedPriceFieldProps, 'price'>
) => {
  const lines = useWatch<Line[]>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    name: `lines` as unknown as any,
  }) as unknown as Line[] | undefined;

  let subTotal = 0;
  if (lines) {
    for (const line of lines) {
      if (line.price && line.quantity) {
        subTotal += line.price * line.quantity;
      }
    }
  }
  return <QuickbooksCalculatedPriceField price={subTotal} {...props} />;
};
